<b3-modal [open]="true" overlay size="md" (b3-close)="close()">
  <b3-modal-header
    *ngIf="title"
    [heading]="title"
    aria-level="2"
    [icon]="headerIcon"
    [attr.icon-tone]="headerIconTone"
    [attr.close-aria-label]="closeButton ? 'Fechar' : null"
    (b3-close)="close()">
  </b3-modal-header>

  <b3-modal-body>
    <div class="box">
      <div id="modal-body-content" [innerHTML]="safeContent"></div>
    </div>
  </b3-modal-body>

  <b3-modal-footer>
    <div *ngIf="modalType === 'confirmation' && actionType === ''" class="app-modal-confirmation__footer">
      <b3-button type="button" variant="outlined" tone="default" id="modal_cancel" (b3-click)="close()">
        Não
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm_modal" (b3-click)="confirm()">
        Sim
      </b3-button>
    </div>

    <div *ngIf="modalType === 'confirmation' && actionType === 'deleteDraft'" class="app-modal-confirmation__footer">
      <b3-button type="button" variant="outlined" tone="default" id="modal_cancel" (b3-click)="close()">
        Cancelar
      </b3-button>
      <b3-button type="button" variant="filled" tone="default" id="btn_confirm_modal" (b3-click)="confirm()">
        Descartar Rascunho
      </b3-button>
    </div>

    <div *ngIf="modalType === 'info' && buttonOk" class="app-modal-confirmation__footer app-modal-confirmation__footer--end">
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        id="btn_confirm__with_buttonOk_modal"
        (b3-click)="confirmWithButtonOk()">
        Sim
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
